import { ARTICLE_TYPES } from '@/constants/article.constants';
import type { TypeArticleWithoutUnresolvableLinksResponse } from '@/contentful/types';

const getArticleLabel = (
  article: TypeArticleWithoutUnresolvableLinksResponse
): string | null => {
  const {
    primaryDisplayLabel,
    primarySector,
    sectors,
    locations,
    categories,
    status,
    pillar,
    sponsored,
    type
  } = article.fields;

  if (type === ARTICLE_TYPES.SPONSORED || sponsored) {
    return 'Sponsored Content';
  }

  if (primaryDisplayLabel) {
    return primaryDisplayLabel.fields.name;
  }

  if (primarySector) {
    return primarySector.fields.name;
  }
  if (sectors && sectors[0]) {
    return sectors[0]?.fields.name;
  }
  if (locations && locations[0]) {
    return locations[0]?.fields.name;
  }
  if (categories && categories[0]) {
    return categories[0]?.fields.name;
  }
  if (status) {
    return status.fields.name;
  }
  if (pillar) {
    return pillar.fields.name;
  }
  return null;
};

export default getArticleLabel;
